import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const TaskDistributionWidget = () => {
  const [tabValue, setTabValue] = useState("This Week");
  const [awaitRender, setAwaitRender] = useState(true);

  useEffect(() => {
    setAwaitRender(false);
  }, []);

  if (awaitRender) {
    return <div className="text-center py-12 text-gray-200">Loading...</div>;
  }

  const ranges = {
    "This Week": "This Week",
    "Last Week": "Last Week",
  };

  const labels = ["Food", "Beverage", "Warehouse", "Issues"];

  const series = {
    "This Week": [40, 28, 30, 15],
    "Last Week": [38, 25, 29, 14],
  };

  const overview = {
    "This Week": { new: 594, completed: 287 },
    "Last Week": { new: 526, completed: 260 },
  };

  const chartOptions = {
    chart: {
      type: "polarArea",
      toolbar: { show: false },
      background: "#1E293B", // Tailwind gray-900
    },
    labels: labels,
    stroke: {
      colors: ["#1f2937"], // gray-800
    },
    fill: {
      opacity: 0.9,
    },
    legend: {
      position: "bottom",
      labels: {
        colors: "#d1d5db", // Tailwind gray-300
      },
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeColor: "#374151", // Tailwind gray-700
        },
        spokes: {
          connectorColors: "#374151",
        },
      },
    },
    theme: {
      mode: "dark",
    },
    colors: ["#ef4444", "#f97316", "#3b82f6", "#10b981"],
  };

  return (
    <div className="bg-dry border border-border text-gray-200 rounded-xl shadow p-6 flex flex-col w-full h-full">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
        <h2 className="text-lg font-semibold">Task Distribution</h2>
        <div className="flex gap-2 mt-4 sm:mt-0">
          {Object.entries(ranges).map(([key, label]) => (
            <button
              key={key}
              onClick={() => setTabValue(label)}
              className={`px-4 py-1 rounded-full text-sm font-medium ${
                tabValue === label
                  ? "bg-gray-100 text-gray-900"
                  : "bg-gray-800 text-gray-300"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Chart */}
      <div className="flex-1">
        <ReactApexChart
          options={chartOptions}
          series={series[tabValue]}
          type="polarArea"
          height={300}
        />
      </div>

      {/* Overview Bottom */}
      <div className="grid grid-cols-2 divide-x border-t border-gray-700 mt-6">
        <div className="flex flex-col items-center justify-center p-6">
          <p className="text-4xl font-bold">{overview[tabValue].new}</p>
          <p className="text-sm text-gray-400 mt-2">New tasks</p>
        </div>
        <div className="flex flex-col items-center justify-center p-6">
          <p className="text-4xl font-bold">{overview[tabValue].completed}</p>
          <p className="text-sm text-gray-400 mt-2">Completed tasks</p>
        </div>
      </div>
    </div>
  );
};

export default TaskDistributionWidget;
